export const vi = {
  common: {
    save: 'Lưu',
    cancel: 'Huỷ',
    edit: 'Sửa',
    delete: 'Xoá',
    retry: 'Thử lại',
    saved: 'Đã lưu',
    loadError: 'Không tải được dữ liệu',
    search: 'Tìm kiếm…',
    columns: 'Cột',
    export: 'Xuất CSV',
    selected: 'Đã chọn {{count}}',
    all: 'Tất cả',
    none: '—',
    yes: 'Có',
    no: 'Không',
    notes: 'Ghi chú',
  },
  types: { network: 'Network/MCN', distributor: 'Phân phối nội dung' },
  status: { active: 'Đang hợp tác', inactive: 'Ngừng hợp tác' },
  contractStatus: {
    upcoming: 'Chưa hiệu lực',
    active: 'Còn hiệu lực',
    expiring: 'Sắp hết hạn',
    expired: 'Hết hạn',
  },
  kinds: { network: 'Network/MCN', distribution: 'Phân phối' },
  partners: {
    title: 'Đối tác',
    description: 'Đối tác Network/MCN và đối tác phân phối nội dung.',
    add: 'Thêm đối tác',
    name: 'Tên giao dịch',
    legalName: 'Tên pháp lý',
    taxCode: 'Mã số thuế',
    country: 'Quốc gia',
    countryHint: 'Mã 2 chữ cái, ví dụ VN, US.',
    address: 'Địa chỉ',
    types: 'Loại đối tác',
    status: 'Trạng thái',
    networks: 'Network',
    activeContracts: 'HĐ còn hiệu lực',
    nextExpiry: 'Hết hạn gần nhất',
    empty: 'Chưa có đối tác',
    back: 'Danh sách đối tác',
    info: 'Thông tin',
    contacts: 'Liên hệ',
    contracts: 'Hợp đồng',
    pickTypes: 'Chọn ít nhất một loại',
  },
  contacts: {
    add: 'Thêm người liên hệ',
    name: 'Họ tên',
    title: 'Chức vụ',
    email: 'Email',
    phone: 'Điện thoại',
    empty: 'Chưa có người liên hệ',
    remove: 'Xoá dòng',
  },
  networks: {
    add: 'Thêm Network',
    name: 'Tên Network',
    code: 'Mã / CMS',
    defaultRate: 'Tỷ lệ LICO nhận mặc định',
    effectiveFrom: 'Áp dụng từ ngày',
    rateHint: 'Kênh YouTube mới của Network này lấy tỷ lệ này (sửa được trên từng kênh).',
    changeRate: 'Đổi tỷ lệ',
    history: 'Lịch sử tỷ lệ',
    empty: 'Chưa có Network',
    notNetwork: 'Đối tác này không phải Network/MCN.',
    applyToChannels: 'Áp dụng cho các kênh đang dùng tỷ lệ cũ',
    channelsAffected_one: '{{count}} kênh đang dùng tỷ lệ cũ {{rate}}:',
    channelsAffected_other: '{{count}} kênh đang dùng tỷ lệ cũ {{rate}}:',
    noChannelsAffected: 'Không có kênh nào đang dùng tỷ lệ cũ.',
    channelsHint:
      'Kênh có tỷ lệ riêng giữ nguyên. Tháng đã chốt không thay đổi. Doanh thu được tính lại trong giây lát.',
    hidden: 'Bạn không có quyền xem tỷ lệ.',
  },
  contracts: {
    title: 'Hợp đồng',
    description: 'Hợp đồng và phụ lục với đối tác, file scan và nhắc hết hạn.',
    add: 'Thêm hợp đồng',
    addAddendum: 'Thêm phụ lục',
    number: 'Số hợp đồng',
    name: 'Tên hợp đồng',
    partner: 'Đối tác',
    network: 'Network',
    kind: 'Loại',
    parent: 'Hợp đồng gốc',
    signedOn: 'Ngày ký',
    startsOn: 'Ngày hiệu lực',
    endsOn: 'Ngày hết hạn',
    endsOnHint: 'Để trống nếu không thời hạn.',
    autoRenew: 'Tự gia hạn',
    rate: 'Tỷ lệ LICO nhận (%)',
    territories: 'Lãnh thổ',
    territoriesHint: 'Mã quốc gia cách nhau bằng dấu phẩy, ví dụ VN, TH, ID; WW = toàn cầu.',
    exclusive: 'Độc quyền',
    status: 'Trạng thái',
    daysLeft_one: 'còn {{count}} ngày',
    daysLeft_other: 'còn {{count}} ngày',
    files: 'File scan',
    filesHint: 'PDF, JPG, PNG hoặc WebP, tối đa 20 MB mỗi file.',
    upload: 'Tải file lên',
    uploaded: 'Đã tải lên',
    noFiles: 'Chưa có file',
    removeFile: 'Xoá file',
    removeFileConfirm: 'Xoá file {{name}}?',
    titles: 'Bộ nội dung được cấp phép',
    noTitles: 'Chưa chọn bộ nội dung',
    addenda: 'Phụ lục',
    noAddenda: 'Chưa có phụ lục',
    empty: 'Chưa có hợp đồng',
    back: 'Danh sách hợp đồng',
    pickPartner: 'Chọn đối tác…',
    pickNetwork: 'Không gắn Network',
    worldwide: 'Toàn cầu',
  },
  widget: {
    all: 'Tất cả hợp đồng',
    none: 'Không có hợp đồng nào hết hạn trong 30 ngày tới',
    daysLeft: 'còn {{count}} ngày',
    today: 'hết hạn hôm nay',
    autoRenew: 'tự gia hạn',
    more: 'và {{count}} hợp đồng khác',
  },
  titles: {
    title: 'Bộ nội dung',
    description: 'Danh mục bộ nội dung / series dùng trong hợp đồng phân phối.',
    add: 'Thêm bộ nội dung',
    name: 'Tên',
    descriptionLabel: 'Mô tả',
    contracts: 'Số hợp đồng',
    empty: 'Chưa có bộ nội dung',
  },
  errors: {
    partners: {
      duplicate_partner: 'Tên đối tác đã tồn tại.',
      duplicate_network: 'Tên Network đã tồn tại.',
      duplicate_contract: 'Số hợp đồng đã tồn tại.',
      duplicate_title: 'Tên bộ nội dung đã tồn tại.',
      not_network_partner: 'Đối tác này không phải Network/MCN.',
      titles_need_distribution: 'Chỉ hợp đồng phân phối mới có bộ nội dung.',
    },
    'core-files': {
      too_large: 'File quá lớn (tối đa 20 MB).',
      unsupported_type: 'Chỉ nhận PDF, JPG, PNG hoặc WebP.',
      missing_file: 'Chưa chọn file.',
    },
    generic: 'Thao tác không thành công. Vui lòng thử lại.',
  },
};

export const en: typeof vi = {
  common: {
    save: 'Save',
    cancel: 'Cancel',
    edit: 'Edit',
    delete: 'Delete',
    retry: 'Retry',
    saved: 'Saved',
    loadError: 'Could not load data',
    search: 'Search…',
    columns: 'Columns',
    export: 'Export CSV',
    selected: '{{count}} selected',
    all: 'All',
    none: '—',
    yes: 'Yes',
    no: 'No',
    notes: 'Notes',
  },
  types: { network: 'Network/MCN', distributor: 'Content distribution' },
  status: { active: 'Active', inactive: 'Inactive' },
  contractStatus: {
    upcoming: 'Not started',
    active: 'Active',
    expiring: 'Expiring',
    expired: 'Expired',
  },
  kinds: { network: 'Network/MCN', distribution: 'Distribution' },
  partners: {
    title: 'Partners',
    description: 'Network/MCN and content distribution partners.',
    add: 'Add partner',
    name: 'Trading name',
    legalName: 'Legal name',
    taxCode: 'Tax code',
    country: 'Country',
    countryHint: 'Two-letter code, e.g. VN, US.',
    address: 'Address',
    types: 'Partner type',
    status: 'Status',
    networks: 'Networks',
    activeContracts: 'Active contracts',
    nextExpiry: 'Next expiry',
    empty: 'No partners yet',
    back: 'Partners',
    info: 'Details',
    contacts: 'Contacts',
    contracts: 'Contracts',
    pickTypes: 'Pick at least one type',
  },
  contacts: {
    add: 'Add contact',
    name: 'Name',
    title: 'Title',
    email: 'E-mail',
    phone: 'Phone',
    empty: 'No contacts yet',
    remove: 'Remove row',
  },
  networks: {
    add: 'Add network',
    name: 'Network name',
    code: 'Code / CMS',
    defaultRate: 'Default LICO share',
    effectiveFrom: 'Effective from',
    rateHint: 'New YouTube channels of this network start with this rate (editable per channel).',
    changeRate: 'Change rate',
    history: 'Rate history',
    empty: 'No networks yet',
    notNetwork: 'This partner is not a Network/MCN.',
    applyToChannels: 'Apply to channels still on the previous rate',
    channelsAffected_one: '{{count}} channel on the previous rate {{rate}}:',
    channelsAffected_other: '{{count}} channels on the previous rate {{rate}}:',
    noChannelsAffected: 'No channel is on the previous rate.',
    channelsHint:
      'Channels with their own rate keep it. Closed months do not change. Revenue is recalculated in a moment.',
    hidden: 'You may not see rates.',
  },
  contracts: {
    title: 'Contracts',
    description: 'Contracts and addenda with partners, scans and expiry reminders.',
    add: 'Add contract',
    addAddendum: 'Add addendum',
    number: 'Contract number',
    name: 'Contract title',
    partner: 'Partner',
    network: 'Network',
    kind: 'Kind',
    parent: 'Main contract',
    signedOn: 'Signed on',
    startsOn: 'Effective from',
    endsOn: 'Ends on',
    endsOnHint: 'Leave empty for no end date.',
    autoRenew: 'Renews automatically',
    rate: 'LICO share (%)',
    territories: 'Territories',
    territoriesHint: 'Country codes separated by commas, e.g. VN, TH, ID; WW = worldwide.',
    exclusive: 'Exclusive',
    status: 'Status',
    daysLeft_one: '{{count}} day left',
    daysLeft_other: '{{count}} days left',
    files: 'Scans',
    filesHint: 'PDF, JPG, PNG or WebP, up to 20 MB each.',
    upload: 'Upload file',
    uploaded: 'Uploaded',
    noFiles: 'No files yet',
    removeFile: 'Remove file',
    removeFileConfirm: 'Remove file {{name}}?',
    titles: 'Licensed titles',
    noTitles: 'No titles selected',
    addenda: 'Addenda',
    noAddenda: 'No addenda yet',
    empty: 'No contracts yet',
    back: 'Contracts',
    pickPartner: 'Pick a partner…',
    pickNetwork: 'No network',
    worldwide: 'Worldwide',
  },
  widget: {
    all: 'All contracts',
    none: 'No contract expires in the next 30 days',
    daysLeft: '{{count}} days left',
    today: 'expires today',
    autoRenew: 'auto-renews',
    more: 'and {{count}} more',
  },
  titles: {
    title: 'Titles',
    description: 'Catalogue of titles / series licensed in distribution contracts.',
    add: 'Add title',
    name: 'Name',
    descriptionLabel: 'Description',
    contracts: 'Contracts',
    empty: 'No titles yet',
  },
  errors: {
    partners: {
      duplicate_partner: 'A partner with this name already exists.',
      duplicate_network: 'A network with this name already exists.',
      duplicate_contract: 'This contract number already exists.',
      duplicate_title: 'A title with this name already exists.',
      not_network_partner: 'This partner is not a Network/MCN.',
      titles_need_distribution: 'Only distribution contracts license titles.',
    },
    'core-files': {
      too_large: 'The file is too large (20 MB max).',
      unsupported_type: 'Only PDF, JPG, PNG or WebP files.',
      missing_file: 'No file selected.',
    },
    generic: 'The action failed. Please try again.',
  },
};
